<template>
  <a-card bordered>
    <span slot="title">
      <a-tag color="green">{{ mode == "Create" ? "Create" : "Edit" }}</a-tag>
      Receivables Employee
    </span>
    <a-spin :spinning="spining" tip="Loading...">
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-row :gutter="12">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
           
            <a-form-model-item label="End User" prop="enduser">
              <a-select
             
              showSearch
              allowClear
              optionFilterProp="children"
              :filterOption="filterOption"
              v-model="form.enduser">
                <a-select-option
                  v-for="item in getAllKaryawan"
                  :key="item.tlc"
                  :value="item.tlc"
                  >{{ item.tlc }} - {{ item.nama }}</a-select-option
                >
              </a-select>
              
            </a-form-model-item>
            <a-form-model-item label="Value" prop="value">
              <a-input-number
                
                class="m-width-full"
                :min="0"
                v-model="form.value"
                @keydown="onlyNumber"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
              ></a-input-number>
            </a-form-model-item>
            <a-form-model-item label="Down Payment" prop="down_payment">
              <a-input-number
                
                class="m-width-full"
                :min="0"
                v-model="form.down_payment"
                @keydown="onlyNumber"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
              ></a-input-number>
            </a-form-model-item>
            <a-form-model-item label="Installment Value " prop="installmentvalue">
              <a-input-number
                
                class="m-width-full"
                :min="0"
                v-model="form.installmentvalue"
                @keydown="onlyNumber"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
              ></a-input-number>
            </a-form-model-item>
            <a-form-model-item label="Installment Amount" prop="installmentamount">
              <a-row :gutter="12">
                <a-col :xs="{ span: 12 }" :lg="{ span: 6 }">
                  <a-input-number
                    
                    :min="0"
                    class="m-width-full m-text-align-right"
                    v-model="form.installmentamount"
                    @keydown="onlyNumber"
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                  ></a-input-number>
                </a-col>
                <a-col :xs="{ span: 12 }" :lg="{ span: 6 }">
                  <div>x Installment</div>
                </a-col>
              </a-row>
            </a-form-model-item>
            
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item label="Description" prop="description">
              <a-input v-model="form.description" />
            </a-form-model-item>
            
            <a-form-model-item label="Note" prop="note">
              <a-textarea v-model="form.note" :rows="5"></a-textarea>
            </a-form-model-item>

            <a-form-model-item ref="file" prop="file" label="File Attachment">
              <a-upload
                v-model="form.file"
                :showUploadList="true"
                :fileList="push"
                :beforeUpload="beforeUpload"
                :remove="handleRemoveList"
              >
                <a-button
                  ref="btndocument"
                  icon="upload"
                  >Select File
                </a-button>
              </a-upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="action">
        <a-button :loading="loading.submit" type="primary" @click="handleSave()">Save</a-button>
      </div>
    </a-spin>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "piutangKaryawan-create",
  props: ["id"],
  mixins: [GlobalMethod],
  data() {
    let doc_validation = (rule, value, callback) => {
      if (!this.isEdit && (this.push == null || this.push.length==0)) {
        callback(new Error("Please input File Attachment"));
      } else {
        callback();
      }
    };
    return {
      mode: "Create",
      loading: {
        submit: false,
      },
      form: {
        enduser: null,
        installmentamount: null,
        installmentvalue: null,
        value: null,
        down_payment: null,
        file: null,
        description: null,
        usedfor: null,
        note: null,
      },
      dataedit: {},
      rules: {
        enduser: {
          required: true,
          message: "Please input End User",
          trigger: "blur",
        },
        installmentamount: {
          required: true,
          message: "Please input Installment Amount",
          trigger: "blur",
        },
        installmentvalue: {
          required: true,
          message: "Please input Installment Value",
          trigger: "blur",
        },
        value: {
          required: true,
          message: "Please input Value",
          trigger: "blur",
        },
        down_payment: {
          required: false,
          message: "Please input Down Payment",
          trigger: "blur",
        },
        file: [{ 
          required: true,
          validator: doc_validation, 
          trigger: "change" 
        }],
        description: {
          required: true,
          message: "Please input Description",
          trigger: "blur",
        },
        usedfor: {
          required: true,
          message: "Please input User For",
          trigger: "blur",
        },
        note: {
          required: false,
          message: "Please input Note",
          trigger: "blur",
        },
      },
      bank: [],
      currency: [],
      push:[],
      spining: false,
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", 
    "getStandartFormatDate","getDateTimeStandartFormat",
    "getAllKaryawan",]),
  },
  watch: {
    dataedit() {
      this.initialData();
    },
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    if (this.id) {
      this.mode = "Edit";
    } else {
      this.mode = "Create";
    }
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleSaveProcess);
    this.fetch();
    this.initialData();
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleSaveProcess);
  },
  methods: {
    moment,
    initialData() {
      this.form = {
        enduser: this.mode == "Edit" ? this.dataedit.end_user : null,
        installmentamount: this.mode == "Edit" ? this.dataedit.installment_amount : null,
        installmentvalue: this.mode == "Edit" ? this.dataedit.installment_value : null,
        value: this.mode == "Edit" ? this.dataedit.value : null,
        file: this.mode == "Edit" ? parseInt(this.dataedit.file) : 0,
        description: this.mode == "Edit" ? this.dataedit.description : null,
        usedfor: this.mode == "Edit" ? this.dataedit.used_for : "1",
        note: this.mode == "Edit" ? this.dataedit.note : null,
      };
    },
    fetch() {
      if (this.id) {
        this.spining = true;
        this.$store
          .dispatch("getRevisiPiutangKaryawan", { auth: this.getAuth, id_manifest: this.id })
          .then((res) => {
            this.dataedit = res.data[0];
            this.mode = "Edit";

            //konversi url to push file
            let typefile = this.dataedit.file_attachment.substr(this.dataedit.file_attachment.lastIndexOf("."));
            
            if (typefile == ".xls"){
              typefile = "data:application/vnd.ms-excel;base64,";
            } else if(typefile == ".xlsx"){
              typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
            } else if(typefile == ".doc"){
              typefile = "data:application/msword;base64,";
            } else if(typefile == ".docx"){
              typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
            } else if(typefile == ".pdf"){
              typefile = "data:application/pdf;base64,";
            } else if(typefile == ".jpeg" || typefile == ".jpg"){
              typefile = "data:image/jpeg;base64,";
            } else if(typefile == ".png"){
              typefile = "data:image/png;base64,";
            }

            var file = this.dataURLtoFile(
              typefile + this.dataedit.files,
              this.dataedit.file_name
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.exist = true;
            file.url = this.$serviceUrl + this.dataedit.file_attachment;
            this.push.push(file);
            this.spining = false;
          });
      }
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleSave() {
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else if (this.mode === "Create") {
        this.confirmMessage("confirm-save");
      }
    },
    handleSaveProcess() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading.submit = true;
        let data = new FormData();
        data.append("tlc",this.getAuth.username);
        data.append("used_for",this.form.usedfor);
        data.append("end_user",this.form.enduser);
        data.append("value",this.form.value);
        data.append("down_payment",this.form.down_payment);
        data.append("description",this.form.description);
        data.append("installment_amount",this.form.installmentamount);
        data.append("installment_value",this.form.installmentvalue);
        data.append("note",this.form.note ? this.form.note :'-');
        data.append("upload_file",this.push[0]);

        let urlpatch= 'submitPiutangKaryawan';
        if(this.mode=='Edit'){
          urlpatch= 'submitRevisiPiutangKaryawan';
          data.append("piutang_karyawan_id",this.id);
        }

        this.$store
          .dispatch(urlpatch, { auth: this.getAuth, payload: data })
          .then((res) => {
            if (this.mode == "edit") {
              this.displayMessage("success-edit");
            } else {
              this.displayMessage("success");
            }
            this.loading.submit = false;
            this.$router.go(-1);
          })
          .catch((err) => {
            this.displayMessageValue("basic-error", err.response.data.message);
            this.loading.submit = false;
          });
      });
    },
    changeusedfor(){
      this.form.enduser = undefined;
    },
    handleRemoveList() {
      this.form.file = undefined;
      this.push = [];
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.push= [file];
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: @padding -@padding -@padding -@padding;
  padding: @padding;
  background-color: darken(white, 5);
  border-top: 1px solid darken(white, 10);
}
</style>
